import type { Column } from '@/components/Organisms/DataTable/DataTable.types';

// Columns matching the image
export const columns: Column[] = [
	{
		key: 'fullname',
		label: 'Full Name',
		width: '150px',
		type: 'string',
		sorter: true,
	},
	{
		key: 'account.name',
		label: 'Clinic',
		width: '200px',
		type: 'string',
		sorter: true,
	},
	{
		key: 'ta_emrid',
		label: 'EMR ID',
		width: '120px',
		type: 'string',
		sorter: true,
	},
	{
		key: 'primaryInsurance.ta_name',
		label: 'Primary Insurance',
		width: '200px',
		type: 'string',
		sorter: true,
	},
	{
		key: 'ta_primarymemberid',
		label: 'Primary Member ID',
		width: '140px',
		type: 'string',
		sorter: true,
	},
];
